// extracted by mini-css-extract-plugin
module.exports = {"historyCollection":"HistoryCollection_historyCollection__2Shui","rtl":"HistoryCollection_rtl__7jPW3"};